export class RestoreVolumeToEbsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "providerVolumeId",
            "baseName": "providerVolumeId",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "EbsRestoreDestination",
            "format": ""
        },
        {
            "name": "recipe",
            "baseName": "recipe",
            "type": "RestoreRecipeRef",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreVolumeToEbsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
